import { LOGOUT } from "app/auth/actionTypes";
import { handleActions } from "redux-actions";
import {
    CLAIM_REWARD_SUCCESS,
    CREATE_LOYALTY_ACCOUNT_SUCCESS,
    FETCH_LOYALTY_SUCCESS,
    FETCH_LOYALTY_FAILURE,
} from "./actionTypes";

export const initialState = {
    loaded: false,
    account: null,
    rewards: null,
    thirdPartyRewards: null,
};

export default handleActions(
    {
        [LOGOUT]: () => initialState,
        [FETCH_LOYALTY_SUCCESS]: (state, { payload }) => ({
            ...state,
            loaded: true,
            account: payload.account || false,
            rewards: payload.rewards || [],
        }),
        [FETCH_LOYALTY_FAILURE]: (state) => ({
            ...state,
            loaded: true,
        }),
        [CREATE_LOYALTY_ACCOUNT_SUCCESS]: (state, { payload }) => ({
            ...state,
            account: payload,
        }),
        [CLAIM_REWARD_SUCCESS]: (state, { payload }) => ({
            ...state,
            account: {
                ...state.account,
                points: payload.points_remaining.earned,
            },
        }),
    },
    initialState,
);
